<template>
  <div class="base-locked-symbol-octagon-2">
    <div class="base-locked-symbol-octagon">
      <svg class="octagon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101 101">
        <polygon points="71.211 0.5 29.789 0.5 0.5 29.789 0.5 71.211 29.789 100.5 71.211 100.5 100.5 71.211 100.5 29.789 71.211 0.5" fill="none" stroke="#fff" stroke-miterlimit="10"/>
      </svg>
      <img class="lock-icon" src="@/assets/img/lock.svg">
    </div>
    <BaseText11 class="title" text="Prove Yourself"/>
    <BaseText6 text="Beat the previous fighters<br>to unlock this round"/>
  </div>
</template>

<script>
import BaseText11 from '@/components/BaseText11/BaseText11'
import BaseText6 from '@/components/BaseText6/BaseText6'
export default {
  components: {
    BaseText11,
    BaseText6
  }
}
</script>

<style lang="scss" scoped>
.base-locked-symbol-octagon-2 {
  position: absolute;
  text-align: center;
}
.title {
  margin: 2rem 0 1rem 0;
}
.base-locked-symbol-octagon {
  position: relative;
  width: 6rem;
  margin: 0 auto;
}
.octagon {
  width: 100%;
  display: block;
}
.lock-icon {
  position: absolute;
  width: 20%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: block;
}
</style>
